import React from 'react'

export const VideoCarousel = () => {
  return (
    <div className='bg-[#D7DEF3]  h-[500px] xsm:h-[300px] sm:h-[350px] md:h-[450px] msm:h-[500px]'>
    </div>
  )
}
